﻿window.taskParameters = function () {
    var instance = {
        chageFlowSelection: function (el) {
            var isChecked = $(el).prop("checked");

            if ($(el).hasClass("select-all")) {
                if (isChecked) {
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow').not('.select-all').not('[default="False"]').prop("checked", isChecked);
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow[default="False"]').prop("checked", false);
                }
                else
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow').not('.select-all').prop("checked", isChecked);
            }
            else {
                var allFlowSelectors = $('#task_parameters_form .flows-selector-container .checkbox-select-flow').not('.select-all');
                var checkedFlowSelectors = $('#task_parameters_form .flows-selector-container .checkbox-select-flow:checked').not('.select-all');

                if (checkedFlowSelectors.length == 0) {
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow.select-all').prop("indeterminate", false).prop("checked", false);
                }
                else if (checkedFlowSelectors.length < allFlowSelectors.length) {
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow.select-all').prop("indeterminate", true);
                }
                else {
                    $('#task_parameters_form .flows-selector-container .checkbox-select-flow.select-all').prop("indeterminate", false).prop("checked", true);

                }
            }
        }
    }
    return instance;
}();

